import { useMemo } from 'react';

import { useClientController_AllLiceDailyReports } from '@/services/hooks';
import type { DailyClientReportResult } from '@/services/types';

import type { DomainQueryOptions } from '../shared/types';

import { mapDailyClientReportResultToDomain } from './mappers';
import type { UseGetRegionDailyLiceReportResult } from './types';

export const useGetRegionDailyLiceReport = (
    clientId: number,
    day: string,
    options?: DomainQueryOptions<DailyClientReportResult>
): UseGetRegionDailyLiceReportResult => {
    const query = useClientController_AllLiceDailyReports(clientId, { day }, options);

    const dailyReport = useMemo(() => {
        if (!query.data?.data) return null;
        return mapDailyClientReportResultToDomain(query.data.data);
    }, [query.data?.data]);

    return {
        data: dailyReport,
        isLoading: query.isPending,
        isFetching: query.isFetching,
        isFetched: query.isFetched,
        error: query.error,
        refetch: query.refetch,
    };
};
